import { AppUtils } from '@utils/app.utils';
import { Component, OnInit, Inject, ViewContainerRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from '@utils/constants';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-worksheet-config-modal',
  templateUrl: './worksheet-config-modal.component.html'
})
export class WorksheetConfigModalComponent implements OnInit {

  public listSelected;
  public listColumns = Constants.worksheetCols;
  public modelList = [];
  public qtdItens = 0;
  public bottomArrow = false;
  public listDefaultColumns = [];

  @ViewChild('worksheetConfig', { read: ViewContainerRef }) parent: ViewContainerRef;

  constructor(
    public dialogRef: MatDialogRef<WorksheetConfigModalComponent>,
    public _NotificationService: NotificationsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: CustomSnackbarService
  ) {
    this.listSelected = data.columns;
    this.bottomArrow = data.bottomArrow;
    this.dialogRef.backdropClick()
      .subscribe(result => {
        this.close();
      });
  }

  ngOnInit() {
    this.setModel();
  }

  setModel() {
    AppUtils.orderObjectAsc(this.listColumns, 'header');
    this.listColumns.forEach((element, index) => {
      if (this.listSelected.some(e => e.field === element.field)) {
        this.modelList[index] = true;
        this.qtdItens++;
      } else {
        this.modelList[index] = false;
      }
      if (element.isDefault) {
        this.listDefaultColumns.push(element);
      }
    });
    AppUtils.orderObjectAsc(this.listDefaultColumns, 'id');
  }

  defaultColumns() {
    this.modelList = [];
    this.qtdItens = 0;
    this.listSelected = [];
    const listDefaultTemp = Constants.worksheetCols;
    AppUtils.orderObjectAsc(listDefaultTemp, 'header');
    listDefaultTemp.forEach((element, index) => {
      this.modelList.push(element.isDefault ? true : false);
      if (element.isDefault) {
        this.qtdItens++;
      }
    });
  }

  clearColumns() {
    this.listColumns.forEach((element, index) => {
      if (this.listSelected.some(e => e.field === element.field && !element.fixedItem)) {
        this.modelList[index] = false;
      }
    });
    this.qtdItens = 0;
  }

  close() {
    const list = [];
    this.listColumns.forEach((element, index) => {
      if (this.modelList[index]) {
        list.push(element);
      }
    });
    AppUtils.orderObjectAsc(list, 'id');
    const listTemp = [];
    const newTemp = [];
    list.forEach(element => {
      const temp = this.data.columns.find(item => item.field === element.field);
      if (temp) { listTemp.push(temp); } else { newTemp.push(element); }
    });
    if (newTemp && newTemp.length > 0) {
      newTemp.forEach(element => { listTemp.push(element); });
    }
    this.dialogRef.close({ data: listTemp });
  }

  onChange(event, index) {
    if (event.checked) {
      if (this.qtdItens > 19) {
        setTimeout(() => {
          this.modelList[index] = false;
        }, 300);
        this._NotificationService.warn('', Constants.WKS_WORKSPACE_WORKSHEET);
        return;
      }
      this.qtdItens++;
    } else {
      this.qtdItens--;
    }
  }

  onResize() {
    this.close();
  }
}
